import React, { type ReactElement } from 'react'
import { useSnapshot } from 'valtio'

import { FORMATTED_UPDATE_CARD_RADIO_VALUES, UpdateCardRadioValues } from '../../utils/UpdateCardRadioValues'
import { rpOccurrenceEditProxy } from './rpOccurrenceEditProxy'
import { handleUpdateCardRadioChange } from './utils'

export function UpdateCardRadioSection (): ReactElement {
  const { updateCardRadioValue } = useSnapshot(rpOccurrenceEditProxy)

  return (
    <div>
      <div className="mt-2 mb-6">
        <div className="flex flex-column items-center my-2">
          <input
            type="radio"
            id={UpdateCardRadioValues.UPDATE_CARD}
            name="update-card"
            value={UpdateCardRadioValues.UPDATE_CARD}
            checked={updateCardRadioValue === UpdateCardRadioValues.UPDATE_CARD}
            onChange={() => { handleUpdateCardRadioChange(UpdateCardRadioValues.UPDATE_CARD) }}
            className="mr-2"
          />
          <label htmlFor={UpdateCardRadioValues.UPDATE_CARD}>
            {FORMATTED_UPDATE_CARD_RADIO_VALUES[UpdateCardRadioValues.UPDATE_CARD]}
          </label>
        </div>

        <div className="flex items-center">
          <input
            type="radio"
            id={UpdateCardRadioValues.DONT_UPDATE_CARD}
            name="update-card"
            value={UpdateCardRadioValues.DONT_UPDATE_CARD}
            checked={updateCardRadioValue === UpdateCardRadioValues.DONT_UPDATE_CARD}
            onChange={() => { handleUpdateCardRadioChange(UpdateCardRadioValues.DONT_UPDATE_CARD) }}
            className="mr-2"
          />
          <label htmlFor={UpdateCardRadioValues.DONT_UPDATE_CARD}>
            {FORMATTED_UPDATE_CARD_RADIO_VALUES[UpdateCardRadioValues.DONT_UPDATE_CARD]}
          </label>
        </div>
      </div>

    </div>
  )
}
